
// src/web/components/group-create-page.jsx

import React from 'react'
import connect from '../../connects/group-create-page'
import {
  SettingsPage,
  SettingsPanel,
} from './settings-page'
import GroupFormPanel from './group-form-panel.jsx'

class GroupCreatePage extends React.Component {
  render() {
    const {
      t,
      active,
      onClose,
    } = this.props

    return (
      <SettingsPage title={t('label:グループ新規作成')}
          active={active}
          onCloseDialog={onClose}
          initialName="profile" >
        <SettingsPanel name="profile"
            label={t('label:新規作成')}
            icon="add_circle"
            params={{ onClose }}
            component={GroupFormPanel} />
      </SettingsPage>
     )
  }
}

export const RawGroupCreatePage = GroupCreatePage
export default connect(GroupCreatePage)



// WEBPACK FOOTER //
// ./src/web/components/group-create-page.jsx